import RUF from "../../../util/redux";

export function modelSetLoanAmount(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      loanAmount: action.payload
    })
  });
}
